function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 52",
    width: "52px",
    height: "52px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface52919638"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 45.132812 9.460938 L 41.546875 7.023438 C 40.554688 6.351562 39.195312 6.609375 38.53125 7.59375 L 20.953125 33.515625 L 12.875 25.4375 C 12.03125 24.59375 10.65625 24.59375 9.8125 25.4375 L 6.742188 28.507812 C 5.898438 29.351562 5.898438 30.726562 6.742188 31.578125 L 19.164062 44 C 19.859375 44.695312 20.953125 45.226562 21.9375 45.226562 C 22.921875 45.226562 23.914062 44.609375 24.554688 43.679688 L 45.710938 12.46875 C 46.382812 11.484375 46.125 10.132812 45.132812 9.460938 Z M 45.132812 9.460938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneWhite);
export default __webpack_public_path__ + "static/media/done-white.03f85a46b45ef9965b36a033e24ac03e.svg";
export { ForwardRef as ReactComponent };